import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  title: string;
};

const Header = ({ title }: Props) => {
  return (
    <Wrapper>
      <TranslationZone />
      <HeaderContainer>
        <button type='button' onClick={() => window.history.back()}>
          <Icon.ChevronLeft width={24} />
        </button>
        <h3>{title}</h3>
        <Box />
      </HeaderContainer>
    </Wrapper>
  );
};
export default Header;

const Wrapper = styled.header`
  display: flex;
  flex-direction: column;
  width: 375px;
  z-index: 60;
  position: fixed;
  top: 0;
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;

const TranslationZone = styled.div`
  height: 40px;
  background: #f1f1f1;
  @media ${(props) => props.theme.mobile} {
    height: 32px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(218, 218, 218, 0.25);
`;

const Box = styled.div`
  width: 24px;
  height: 24px;
`;
